import { QueryClient } from '@tanstack/react-query';
import { ApiClient } from 'bff/ApiClient';
import { atom, createStore } from 'jotai';

export type ApiClientStoreProps = {
  queryClient: QueryClient;
  apiClient: ApiClient;
};

const clientsAtom = atom<ApiClientStoreProps | undefined>(undefined);

const getClientsAtom = atom((get) => {
  const val = get(clientsAtom);
  if (!val) {
    throw new Error('Clients not initialised');
  }

  return val;
});

export const clientStore = createStore();

export const initialiseClients = (clients: ApiClientStoreProps) => {
  clientStore.set(clientsAtom, clients);
  return clientStore;
};

export const clientService = {
  getApiClient: () => clientStore.get(getClientsAtom).apiClient,
  getQueryClient: () => clientStore.get(getClientsAtom).queryClient
};
